import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import Modal from '../../components/Modal';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import dataLayer from '../../utils/data-layer';

const SELECTOR_WRAPPER = '.p-school-onboarding';
const SELECTOR_MODAL = '#js-school-onboarding-modal';

const SELECTOR_SPLASH = '.p-school-onboarding-splash';
const SELECTOR_SPLASH_NEXT = '.p-school-onboarding-splash-next';

const SELECTOR_CONFIRMATION = '.p-school-onboarding-confirmation';
const SELECTOR_CONFIRMATION_CONFIRM_BUTTON = '.p-school-onboarding-confirmation-confirm';

const SELECTOR_SUCCESS = '.p-school-onboarding-success';
const SELECTOR_SUCCESS_BUTTON = '.p-school-onboarding-success--button';

const SELECTOR_STEP = '.p-school-onboarding-step';
const SELECTOR_QUESTION = '.p-school-onboarding-questions';
const SELECTOR_STEP_NEXT = '.p-school-onboarding-step-next';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const IS_LOCAL = false;
class SchoolOnboarding {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		this.formElementsList = {};
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.schoolOnboardingModalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);

		this.schoolOnboardingSplash = SelectorEngine.findOne(SELECTOR_SPLASH, this._wrapper);
		this.schoolOnboardingSplashNext = SelectorEngine.findOne(SELECTOR_SPLASH_NEXT, this.schoolOnboardingSplash);

		this.schoolOnboardingConfirmation = SelectorEngine.findOne(SELECTOR_CONFIRMATION, this._wrapper);
		this.schoolOnboardingConfirmButton = SelectorEngine.findOne(
			SELECTOR_CONFIRMATION_CONFIRM_BUTTON,
			this.schoolOnboardingConfirmation
		);

		this.schoolOnboardingStep = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		this.schoolOnboardingQuestion = SelectorEngine.findOne(SELECTOR_QUESTION, this.schoolOnboardingStep);
		this.schoolOnboardingStepNext = SelectorEngine.findOne(SELECTOR_STEP_NEXT, this.schoolOnboardingStep);

		this.schoolOnboardingSuccess = SelectorEngine.findOne(SELECTOR_SUCCESS, this._wrapper);
		this.schoolOnboardingSuccessButton = SelectorEngine.findOne(SELECTOR_SUCCESS_BUTTON, this.schoolOnboardingSuccess);

		this.schoolOnboardingModal = new Modal(this.schoolOnboardingModalElement, { backdrop: 'static' });
		this.schoolOnboardingModal.isEscapeEventEnable = false;

		this.schoolOnboardingModal.show();

		EventHandler.on(this.schoolOnboardingSplashNext, CLICK_EVENT, () => {
			this.fetchSchoolOnboardingSteps();
		});
		EventHandler.on(this.schoolOnboardingSuccessButton, CLICK_EVENT, () => {
			this.schoolOnboardingModal.hide();
		});
	}
	showSuccessPage() {
		this.schoolOnboardingConfirmation.classList.add(HIDDEN_CLASS);
		this.schoolOnboardingSuccess.classList.remove(HIDDEN_CLASS);
		this.pushStepToDataLayer(4);
	}
	initiateFormGenerator(stepsData) {
		this.schoolOnboardingSplash.classList.add(HIDDEN_CLASS);
		this.schoolOnboardingStep.classList.remove(HIDDEN_CLASS);

		this.formGenerator = new FormGenerator(this.schoolOnboardingQuestion, {
			questions: stepsData,
			totalSteps: 3,
			hasSeparator: true,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-accent-orange',
			isBackButtonEnabled: true,
			backButtonHandlerFirstStep: () => {
				this.schoolOnboardingSplash.classList.remove(HIDDEN_CLASS);
				this.schoolOnboardingStep.classList.add(HIDDEN_CLASS);
			}
		});
		this.formGenerator.onChange((answers) => {
			this.schoolOnboardingStep.classList.add(HIDDEN_CLASS);
			this.schoolOnboardingConfirmation.classList.remove(HIDDEN_CLASS);
			this.prepareRequestObject(answers);
		});

		this.formGenerator.onStepChange(() => {
			const currentStep = this.formGenerator._currentStep - 1;
			this.pushStepToDataLayer(currentStep);
		});


		EventHandler.on(this.schoolOnboardingConfirmButton, CLICK_EVENT, () => {
			const currentStep = this.formGenerator._currentStep
			this.pushStepToDataLayer(currentStep);
			this.schoolOnboardingConfirmButton.disabled = true;
			this.saveSchoolOnboardingSteps(this.answerList);
		});

		this.pushStepToDataLayer(0);
	}

	pushStepToDataLayer(currentStep) {
		try {
			const stepMap = {
				0: "School onboarding started",
				1: "Describe yourself",
				2: "Location",
				3: "Free training interest",
				4: "School onboarding submitted successfully"
			};
		
			const stepCompleted = stepMap[currentStep];
		
			dataLayer.push({
				event: "school_onboarding",
				stepCompleted
			});
		} 
		catch (error) {
		  console.error(error.message);
		}
	  }

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					source: ['LTA Youth Tennis'],
					...this.answerList,
					...formatObject
				};
			}
		}
	}
	async fetchSchoolOnboardingSteps() {
		try {
			const url = '/api/teachermembership/steps';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
	async saveSchoolOnboardingSteps(requestObject) {
		try {
			const url = '/api/teachermembership/SaveTeacherOnboardingDetails';
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { Success, error } = response;
			if (Success) {
				this.showSuccessPage();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
}

const globalSchoolOnboarding = new SchoolOnboarding();
export default globalSchoolOnboarding;
